module.exports = __webpack_public_path__ + "img/calendar-xmark.f8d6079a.svg";